<template>
    <div class="cards-main">
        <complex-slider
            :complexes = "complexes"
        ></complex-slider>
        <button class="cards-main-button cards-main-button_prev _icon-slider_arr-left"></button>
        <button class="cards-main-button cards-main-button_next _icon-slider_arr-right"></button>
        <go-to-complexes-button
            :text=text
        ></go-to-complexes-button>
    </div>
</template>

<script>
export default {
    name: "ComplexSliderWrapper",
    props: {
        complexes: {
            type: Array,
            default: () => []
        },
        text: {
            type: String,
            default: 'View more'
        }
    }
}
</script>
